/* eslint-disable react/prefer-stateless-function */
import React from "react";
import { node, bool } from "prop-types";

class ContentWrapper extends React.Component {
  static propTypes = {
    children: node,
    unwrap: bool,
  };

  render() {
    let childElement = this.props.children;

    // unwrapped pages
    if (this.props.unwrap) {
      childElement = <div className="unwrap">{this.props.children}</div>;
    }

    return <div className="content-wrapper" style={{ minHeight:'auto' }} >{childElement}</div>;
  }
}
export default ContentWrapper



// WEBPACK FOOTER //
// ./src/components/layout/ContentWrapper.js